import { useEffect, useRef } from 'react';
import { useRoom } from '../contexts/RoomContext';
import { roomsApi } from '../services/api';

export const useRooms = () => {
  const { state, setRooms, setLoading, setError } = useRoom();
  const hasAttemptedLoad = useRef(false);

  useEffect(() => {
    // Only attempt to load once
    if (hasAttemptedLoad.current || state.isInitialized) {
      return;
    }

    const fetchRooms = async () => {
      hasAttemptedLoad.current = true;
      
      try {
        setLoading(true);
        setError(null);
        const rooms = await roomsApi.getRooms();
        console.log('DEBUG - Rooms fetched from API:', rooms);
        console.log('DEBUG - Room IDs:', rooms.map(r => ({ id: r.id, name: r.name })));
        setRooms(rooms);
      } catch (error) {
        console.error('Error loading rooms:', error);
        const errorMessage = error instanceof Error ? error.message : 'No se pudieron cargar los escape rooms';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchRooms();
  }, [state.isInitialized, setRooms, setLoading, setError]);

  const refetch = async () => {
    hasAttemptedLoad.current = false;
    try {
      setLoading(true);
      setError(null);
      const rooms = await roomsApi.getRooms();
      setRooms(rooms);
    } catch (error) {
      console.error('Error refetching rooms:', error);
      const errorMessage = error instanceof Error ? error.message : 'No se pudieron cargar los escape rooms';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    ...state,
    refetch,
  };
};